module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('硬件编码')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devHdcode),
      expression: "devHdcode"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.devHdcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devHdcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备型号')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devSerialno),
      expression: "devSerialno"
    }],
    ref: "idSerialNo",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.devSerialno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devSerialno = $event.target.value
      }
    }
  }), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "16px",
      "height": "30px",
      "border": "0px solid red",
      "text-align": "center",
      "line-height": "34px",
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备名称')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devName),
      expression: "devName"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.devName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devName = $event.target.value
      }
    }
  }), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "16px",
      "height": "30px",
      "border": "0px solid red",
      "text-align": "center",
      "line-height": "34px",
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('有效期至')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devValidate),
      expression: "devValidate"
    }],
    ref: "idValidate",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.devValidate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devValidate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备状态')))]), _vm._v(" "), _c('cselect', {
    staticStyle: {
      "position": "relative",
      "height": "30px",
      "min-width": "150px",
      "z-index": "999"
    },
    attrs: {
      "defv": _vm.devSts,
      "ctrl": _vm.ctrlDevSts,
      "csData": _vm.dataDevSts
    },
    model: {
      value: (_vm.devSts),
      callback: function($$v) {
        _vm.devSts = $$v
      },
      expression: "devSts"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备锁定')))]), _vm._v(" "), _c('radio', {
    ref: "idLock1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'DevLock',
      "val": 1,
      "capt": _vm.getLangText('是')
    },
    model: {
      value: (_vm.devLock),
      callback: function($$v) {
        _vm.devLock = $$v
      },
      expression: "devLock"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idLock0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'DevLock',
      "val": 0,
      "capt": _vm.getLangText('否')
    },
    model: {
      value: (_vm.devLock),
      callback: function($$v) {
        _vm.devLock = $$v
      },
      expression: "devLock"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('支持离线')))]), _vm._v(" "), _c('radio', {
    ref: "idMode1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'DevMode',
      "val": 1,
      "capt": _vm.getLangText('是')
    },
    model: {
      value: (_vm.devMode),
      callback: function($$v) {
        _vm.devMode = $$v
      },
      expression: "devMode"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idMode0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'DevMode',
      "val": 0,
      "capt": _vm.getLangText('否')
    },
    model: {
      value: (_vm.devMode),
      callback: function($$v) {
        _vm.devMode = $$v
      },
      expression: "devMode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('设备定位')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devLocate),
      expression: "devLocate"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.devLocate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devLocate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "border": "0px solid red",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "50px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("取消")))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "50px",
      "float": "right"
    },
    on: {
      "click": _vm.onOKClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("确定")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e720bf30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/devInfo.vue
// module id = 808
// module chunks = 1